import { compose } from 'recompose';

import UsersList from './UsersList';

const enhance = compose();

export default enhance(UsersList);
